module.exports = __webpack_public_path__ + "img/brand_home_web.ff8bb24.svg";